import React from "react";
import { DoctorRegisterDiv } from "./style";
import llogo from "../../../../assets/images/llogo.png";
import { Link } from "react-router-dom";

function DoctorRegister() {
  return (
    <DoctorRegisterDiv>
      <div className=" row inner-container">
        <div className="col-md-6 left-div">
          <img src={llogo} alt="" />
          <h3>
            Register as a <br/>
            <span>Doctor.</span>
          </h3>
          <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Nisi doloribus non.</p>
        </div>

        <div className="col-md-6 right-div">
          <form>
            <div className="form-group">
              <input
                type="email"
                className="form-control"
                id="exampleInputEmail1"
                aria-describedby="emailHelp"
                placeholder=" Enter Email Address"
              />
              <small id="emailHelp" className="form-text text-muted">
                We'll never share your email with anyone else.
              </small>
            </div>

            <div className="form-group">
              <input
                type="password"
                className="form-control"
                id="exampleInputPassword1"
                placeholder="Password"
              />
            </div>

            <div className="form-check">
              <input
                type="checkbox"
                className="form-check-input"
                id="exampleCheck1"
              />
              <label className="form-check-label" for="exampleCheck1">
                Checking the box shows you comply with medfirst's Terms and
                Condition{" "}
              </label>
            </div>

            <button type="submit" className="btn">
              Create Account
            </button>
          </form>
          <div className="last-part">
            <h4>No Account?</h4>
            <Link>
              <h4>
                <span>Create Account</span>
              </h4>
            </Link>
          </div>
        </div>
      </div>
    </DoctorRegisterDiv>
  );
}

export default DoctorRegister;